import "core-js/modules/es6.string.trim";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.for-each";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n                @media (max-width: ", "em) {\n                    ", "\n                }"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import dedent from 'dedent';

var generateMediaBreakpoints = function generateMediaBreakpoints(breakpoints) {
  var media = {};
  Object.entries(breakpoints).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        breakpointKey = _ref2[0],
        breakpointValue = _ref2[1];

    if (breakpointValue.width) {
      var emSize = breakpointValue.width / 16;

      media[breakpointKey] = function (css) {
        return dedent(_templateObject(), emSize, css.trim());
      };
    }
  });
  return media;
};

export { generateMediaBreakpoints };